import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ScrollReveal from 'scrollreveal';
import styles from './SecondScreen.module.css';
import YouTubeShort from '../components/shorts/Shorts';

const SecondScreen = () => {
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const [showContactForm, setShowContactForm] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: '',
    city: '',
    experience: '',
    goal: '',
    timeCommitment: '',
    disciplineAware: '',
    openQuestion: ''
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [agreed, setAgreed] = useState(false);

  const serverUrl = "https://dynamic-server-dfc88e1f1c54.herokuapp.com/leads/newLead";
  const reciver = "riseupnon@gmail.com";

  const handleWhatsAppClick = () => {
    setShowContactForm(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = 'נא להזין שם מלא';
    }

    const phoneRegex = /^0(5\d|[23489])\d{7}$/;
    if (!formData.phone.trim()) {
      newErrors.phone = 'נא להזין מספר טלפון';
    } else if (!phoneRegex.test(formData.phone.replace(/[-\s]/g, ''))) {
      newErrors.phone = 'נא להזין מספר טלפון תקין';
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim()) {
      newErrors.email = 'נא להזין אימייל';
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = 'נא להזין אימייל תקין';
    }

    if (!formData.city.trim()) {
      newErrors.city = 'נא להזין עיר';
    }

    if (!formData.experience) {
      newErrors.experience = 'נא לבחור תשובה';
    }

    if (!formData.goal) {
      newErrors.goal = 'נא לבחור תשובה';
    }

    if (!formData.timeCommitment) {
      newErrors.timeCommitment = 'נא לבחור תשובה';
    }

    if (!formData.disciplineAware) {
      newErrors.disciplineAware = 'נא לבחור תשובה';
    }

    if (!agreed) {
      newErrors.agreed = 'יש לאשר את תנאי השימוש';
    }

    setErrors(newErrors);
    
    if (Object.keys(newErrors).length > 0) {
      const firstErrorField = Object.keys(newErrors)[0];
      setTimeout(() => {
        const errorElement = document.querySelector(`[name="${firstErrorField}"]`) || 
                            document.querySelector(`.${styles.errorText}`);
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (errorElement.focus) {
            errorElement.focus();
          }
        }
      }, 100);
    }
    
    return Object.keys(newErrors).length === 0;
  };

  const handleContactSubmit = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);

    const detailedInfo = `
עיר: ${formData.city}
---
1. ניסיון במסחר: ${formData.experience}
2. מטרה עיקרית: ${formData.goal}
3. זמן שבועי ללמידה: ${formData.timeCommitment}
4. מודעות למשמעת נדרשת: ${formData.disciplineAware}
5. שאלה פתוחה: ${formData.openQuestion || 'לא צוין'}
    `.trim();

    const serverData = {
      name: formData.fullName,
      phone: formData.phone.replace(/[-\s]/g, ''),
      email: formData.email,
      reason: detailedInfo,
      reciver: reciver
    };

    try {
      const response = await fetch(serverUrl, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(serverData)
      });

      if (response.ok) {
        setSubmitted(true);
        
        // מעבר לדף תודה אחרי 1.5 שניות
        setTimeout(() => {
          navigate('/תודה');
        }, 1500);
      } else {
        throw new Error('Failed to submit');
      }
    } catch (error) {
      alert("התרחשה שגיאה, אנא נסו שוב מאוחר יותר");
      console.error('Error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const sr = ScrollReveal({
      origin: 'bottom',
      distance: '30px',
      duration: 800,
      delay: 100,
      easing: 'cubic-bezier(0.5, 0, 0, 1)',
      reset: false,
      viewFactor: 0.15,
    });

    sr.reveal(`.${styles.weBothKnowSection}`, {
      origin: 'bottom',
      distance: '40px',
      duration: 900,
    });

    sr.reveal(`.${styles.reasonItem}`, {
      origin: 'right',
      distance: '25px',
      duration: 600,
      interval: 80,
    });

    sr.reveal(`.${styles.situationsTitle}`, {
      origin: 'bottom',
      distance: '30px',
      duration: 800,
    });

    sr.reveal(`.${styles.situationText}`, {
      origin: 'bottom',
      distance: '20px',
      duration: 600,
      interval: 100,
    });

    sr.reveal(`.${styles.freedomCard}`, {
      origin: 'bottom',
      distance: '30px',
      duration: 700,
      interval: 120,
      scale: 0.95,
    });

    sr.reveal(`.${styles.situationHighlight}`, {
      origin: 'bottom',
      distance: '25px',
      duration: 700,
    });

    sr.reveal(`.${styles.situationConclusion}`, {
      origin: 'bottom',
      distance: '30px',
      duration: 800,
    });

    sr.reveal(`.${styles.videoSectionLight}`, {
      origin: 'bottom',
      distance: '40px',
      duration: 900,
    });

    sr.reveal(`.${styles.talkRealTitle}`, {
      origin: 'bottom',
      distance: '35px',
      duration: 800,
    });

    sr.reveal(`.${styles.talkRealCard}`, {
      origin: 'bottom',
      distance: '35px',
      duration: 700,
      interval: 150,
      scale: 0.97,
    });

    sr.reveal(`.${styles.mythsTitle}`, {
      origin: 'bottom',
      distance: '30px',
      duration: 800,
    });

    sr.reveal(`.${styles.mythsTitleSub}`, {
      origin: 'bottom',
      distance: '25px',
      duration: 700,
      delay: 150,
    });

    sr.reveal(`.${styles.mythCard}`, {
      origin: 'bottom',
      distance: '30px',
      duration: 650,
      interval: 100,
      scale: 0.97,
    });

    sr.reveal(`.${styles.finalCtaSection}`, {
      origin: 'bottom',
      distance: '40px',
      duration: 900,
      scale: 0.98,
    });

    sr.reveal(`.${styles.ctaButton}, .${styles.ctaButtonLight}, .${styles.ctaButtonLarge}`, {
      origin: 'bottom',
      distance: '20px',
      duration: 600,
      delay: 200,
    });

    return () => {
      sr.destroy();
    };
  }, []);

  const myths = [
    {
      myth: '"זה הימורים, לא מקצוע אמיתי"',
      truth: 'מסחר יומי הוא מיומנות נרכשת עם כללים ברורים, ניהול סיכונים ואסטרטגיה מוכחת. בדיוק כמו כל מקצוע אחר.',
    },
    {
      myth: '"רוב האנשים מפסידים, גם אני אפסיד"',
      truth: 'רוב האנשים גם לא מצליחים בעסקים - אבל מי שלומד נכון, עם ליווי צמוד ושיטה מוכחת, מצליח.',
    },
    {
      myth: '"אין לי משמעת בשביל זה"',
      truth: 'המשמעת נבנית דרך השיטה והליווי. אנחנו מלמדים אותך לא רק את הטכניקה, אלא גם את הפן המנטלי.',
    },
    {
      myth: '"זה מסובך, מלא גרפים ומספרים"',
      truth: 'השיטה שלנו מפשטת את הכל. אחרי כמה שבועות תקרא גרפים כמו שאתה קורא עברית.',
    },
  ];

  const freedomBenefits = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22 2L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M22 2L15 22l-4-9-9-4L22 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      text: 'רוצה לטוס לחו"ל לשבועיים?',
      highlight: 'אתה עובד משם.',
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <polyline points="9,22 9,12 15,12 15,22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      text: 'רוצה לעבור לדירה יותר גדולה?',
      highlight: 'אפשרי.',
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 1v22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      text: 'רוצה לחיות בראש שקט כלכלית?',
      highlight: 'זה מה שמסחר יומי נותן.',
    },
  ];

  return (
    <section className={styles.section} ref={sectionRef}>
      {/* Part 1: Light Background */}
      <div className={styles.partOne}>
        <div className={styles.container}>
          {/* We Both Know Section */}
          <div className={styles.weBothKnowSection}>
            <h2 className={styles.weBothKnowTitle}>
              שנינו יודעים למה אתה כאן
            </h2>
            
            <div className={styles.reasonsList}>
              <div className={styles.reasonItem}>
                <span className={styles.reasonArrow}>
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
                  </svg>
                </span>
                <p>אתה כאן כי <strong>נמאס לך לחיות מחודש לחודש</strong> ולנסות לחסוך כל שקל</p>
              </div>
              
              <div className={styles.reasonItem}>
                <span className={styles.reasonArrow}>
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
                  </svg>
                </span>
                <p>אתה כאן כי <strong>אתה רוצה חופש אמיתי</strong> - לעבוד מאיפה שבא לך, מתי שבא לך</p>
              </div>
              
              <div className={styles.reasonItem}>
                <span className={styles.reasonArrow}>
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
                  </svg>
                </span>
                <p>אתה כאן כי <strong>תמיד התעניינת בשוק ההון</strong> והבנת שאפשר להרוויח סכומים אדירים מהתחום</p>
              </div>
              
              <div className={styles.reasonItem}>
                <span className={styles.reasonArrow}>
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
                  </svg>
                </span>
                <p>אתה כאן כי <strong>אתה דואג לעתיד הכלכלי שלך</strong> ומסחר יומי בשוק ההון תמיד קרץ לך</p>
              </div>
              
              <div className={styles.reasonItem}>
                <span className={styles.reasonArrow}>
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
                  </svg>
                </span>
                <p>אתה כאן כי <strong>ראית אחרים שעשו את זה</strong> - ושאלת את עצמך "למה לא אני?"</p>
              </div>
            </div>
            
            <div className={styles.weBothKnowBottom}>
              <p className={styles.bottomText}>
                אם זיהית את עצמך באחד מהמשפטים האלה - <strong>אתה בדיוק במקום הנכון.</strong>
              </p>
            </div>
          </div>

          {/* Relatable Situations Section */}
          <div className={styles.situationsSection}>
            <h3 className={styles.situationsTitle}>תדמיין רגע את זה...</h3>
            
            <div className={styles.situationsContent}>
              <p className={styles.situationText}>
                אתה קם בבוקר בלי שעון מעורר. יושב עם קפה, פותח את הלפטופ, ותוך שעתיים-שלוש סוגר את יום העבודה.
              </p>
              
              <p className={styles.situationText}>
                השאר של היום? שלך. חדר כושר, חברים, טיול, או סתם לא לעשות כלום - <strong>כי אתה יכול להרשות לעצמך.</strong>
              </p>
              
              <p className={styles.situationText}>
                לא צריך לבקש חופש מאף אחד. לא צריך להתחנן על העלאה. לא צריך לספור ימים עד המשכורת.
              </p>
              
              {/* Freedom Benefits */}
              <div className={styles.freedomGrid}>
                {freedomBenefits.map((benefit, index) => (
                  <div key={index} className={styles.freedomCard}>
                    <div className={styles.freedomIcon}>
                      {benefit.icon}
                    </div>
                    <div className={styles.freedomContent}>
                      <span className={styles.freedomText}>{benefit.text}</span>
                      <span className={styles.freedomHighlight}>{benefit.highlight}</span>
                    </div>
                  </div>
                ))}
              </div>
              
              <p className={styles.situationHighlight}>
                עכשיו תעצור רגע ותחשוב:
              </p>
              
              <p className={styles.situationText}>
                יש אנשים שחיים ככה כבר היום. הם לא יותר חכמים ממך. הם לא יותר מוכשרים. 
              </p>
              
              <p className={styles.situationText}>
                פשוט <span className={styles.greenText}>מישהו לימד אותם איך לעשות את זה נכון.</span>
              </p>
              
              <p className={styles.situationConclusion}>
                השאלה היחידה היא - <strong>למה שזה לא יהיה אתה?</strong>
              </p>
            </div>
          </div>

          {/* Video Testimonials Section - In Light Part */}
          <div className={styles.videoSectionLight}>
            <h3 className={styles.videoTitleLight}>תשמע קצת מהם:</h3>
            
            <div className={styles.videoPlaceholder}>
              <YouTubeShort/>
            </div>
            
            <button onClick={handleWhatsAppClick} className={styles.ctaButtonLight}>
              אני רוצה להפוך לסוחר רווחי!
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Part 2: Dark Section */}
      <div className={styles.partTwo}>
        <div className={styles.container}>
          {/* Talk Real Section */}
          <div className={styles.talkRealSection}>
            <h2 className={styles.talkRealTitle}>
              לפני שנרחיב על הכל,<br/> חשוב לי שתדע 2 דברים:
            </h2>
            
            <div className={styles.talkRealContent}>
              <div className={styles.talkRealCard}>
                <div className={styles.cardNumber}>01</div>
                <h3 className={styles.talkRealCardTitle}>אתה לא צריך להיות גאון במתמטיקה</h3>
                <p className={styles.talkRealCardText}>
                  רוב האנשים חושבים שמסחר בשוק ההון דורש תואר בכלכלה או להיות חנון של מספרים. 
                  <strong> זה פשוט לא נכון.</strong> מה שצריך זה שיטה ברורה, משמעת, ומישהו שילווה אותך עד שתבין את זה לבד. 
                  אנחנו לוקחים בחורים בדיוק כמוך - בלי רקע, בלי ניסיון - והופכים אותם לסוחרים רווחיים.
                </p>
              </div>
              
              <div className={styles.talkRealCard}>
                <div className={styles.cardNumber}>02</div>
                <h3 className={styles.talkRealCardTitle}>זה לא עוד קורס שתשכח ממנו אחרי שבוע</h3>
                <p className={styles.talkRealCardText}>
                  ניסית כבר קורסים? ראית סרטונים ביוטיוב? קנית איזה מדריך ב-PDF?
                  <strong> אנחנו יודעים למה זה לא עבד.</strong> כי אף אחד לא היה שם בשבילך כשנתקעת. 
                  אצלנו יש שיעורים פרונטליים, כיתות קטנות של עד 10 אנשים, ותגבורים שבועיים למשך שנה שלמה. 
                  אתה לא לבד בזה.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Part 3: Light Section for Myths */}
      <div className={styles.partThree}>
        <div className={styles.container}>
          {/* Myths Section */}
          <div className={styles.mythsSection}>
            <h2 className={styles.mythsTitle}>
              ואם הגעת לכאן, אתה כנראה מתחיל להבין ש..
            </h2>
            
            <h2 className={styles.mythsTitleSub}>
              כל מה שסיפרו לך על מסחר
              <span className={styles.strike}> לא נכון</span>
            </h2>
            
            <div className={styles.mythsGrid}>
              {myths.map((item, index) => (
                <div 
                  key={index} 
                  className={styles.mythCard}
                >
                  <div className={styles.mythHeader}>
                    <span className={styles.mythIcon}>✕</span>
                    <p className={styles.mythText}>{item.myth}</p>
                  </div>
                  <div className={styles.truthHeader}>
                    <span className={styles.truthIcon}>
                      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
                      </svg>
                    </span>
                    <p className={styles.truthText}>{item.truth}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA Section */}
          <div className={styles.finalCtaSection}>
            <h3 className={styles.finalCtaTitle}>אז מה עושים עכשיו?</h3>
            <p className={styles.finalCtaText}>
              פשוט - לומדים את המקצוע מאלה שכבר עשו את זה. <strong>ובאחריות מלאה.</strong>
            </p>
            <button onClick={handleWhatsAppClick} className={styles.ctaButtonLarge}>
              לחץ כאן לשיחת ייעוץ ללא עלות!
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Contact Form Overlay */}
      <div className={`${styles.contactOverlay} ${showContactForm ? styles.active : ''}`}>
        <div className={styles.contactForm}>
          <button className={styles.closeButton} onClick={() => setShowContactForm(false)}>
            ×
          </button>

          <div className={styles.formHeader}>
            <h2 className={styles.formTitle}>מלא את הטופס וקבל התאמה אישית</h2>
            <p className={styles.formSubtitle}>למסלול מסחר מקצועי עם חשבון ממומן</p>
          </div>

          <div className={styles.formScrollContainer}>
            {/* Personal Details Section */}
            <div className={styles.formSection}>
              <h3 className={styles.sectionTitle}>
                <span className={styles.sectionIcon}>
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                  </svg>
                </span>
                פרטים אישיים
              </h3>

              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>שם מלא</label>
                  <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    className={`${styles.formInput} ${errors.fullName ? styles.inputError : ''}`}
                    placeholder="השם המלא שלך"
                    disabled={isSubmitting || submitted}
                  />
                  {errors.fullName && <p className={styles.errorText}>{errors.fullName}</p>}
                </div>

                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>טלפון</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className={`${styles.formInput} ${errors.phone ? styles.inputError : ''}`}
                    placeholder="050-1234567"
                    disabled={isSubmitting || submitted}
                  />
                  {errors.phone && <p className={styles.errorText}>{errors.phone}</p>}
                </div>
              </div>

              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>אימייל</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className={`${styles.formInput} ${errors.email ? styles.inputError : ''}`}
                    placeholder="your@email.com"
                    disabled={isSubmitting || submitted}
                  />
                  {errors.email && <p className={styles.errorText}>{errors.email}</p>}
                </div>

                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>עיר</label>
                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    className={`${styles.formInput} ${errors.city ? styles.inputError : ''}`}
                    placeholder="עיר מגורים"
                    disabled={isSubmitting || submitted}
                  />
                  {errors.city && <p className={styles.errorText}>{errors.city}</p>}
                </div>
              </div>
            </div>

            {/* Question 1 */}
            <div className={styles.formSection}>
              <h3 className={styles.questionTitle}>
                <span className={styles.questionNumber}>1</span>
                איזה ניסיון יש לך במסחר בשוק ההון?
              </h3>
              <div className={styles.radioGroup}>
                <label className={`${styles.radioOption} ${formData.experience === 'אין לי ניסיון בכלל' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="experience"
                    value="אין לי ניסיון בכלל"
                    checked={formData.experience === 'אין לי ניסיון בכלל'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>אין לי ניסיון בכלל</span>
                </label>
                <label className={`${styles.radioOption} ${formData.experience === 'סוחר מעט, אך עדיין לא עקבי' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="experience"
                    value="סוחר מעט, אך עדיין לא עקבי"
                    checked={formData.experience === 'סוחר מעט, אך עדיין לא עקבי'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>סוחר מעט, אך עדיין לא עקבי</span>
                </label>
                <label className={`${styles.radioOption} ${formData.experience === 'יש לי ניסיון ורוצה להתקדם למסחר מקצועי עם חשבונות ממומנים' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="experience"
                    value="יש לי ניסיון ורוצה להתקדם למסחר מקצועי עם חשבונות ממומנים"
                    checked={formData.experience === 'יש לי ניסיון ורוצה להתקדם למסחר מקצועי עם חשבונות ממומנים'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>יש לי ניסיון ורוצה להתקדם למסחר מקצועי עם חשבונות ממומנים</span>
                </label>
              </div>
              {errors.experience && <p className={styles.errorText}>{errors.experience}</p>}
            </div>

            {/* Question 2 */}
            <div className={styles.formSection}>
              <h3 className={styles.questionTitle}>
                <span className={styles.questionNumber}>2</span>
                מה המטרה העיקרית שלך בלימודי מסחר?
              </h3>
              <div className={styles.radioGroup}>
                <label className={`${styles.radioOption} ${formData.goal === 'יצירת הכנסה נוספת מהצד' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="goal"
                    value="יצירת הכנסה נוספת מהצד"
                    checked={formData.goal === 'יצירת הכנסה נוספת מהצד'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>יצירת הכנסה נוספת מהצד</span>
                </label>
                <label className={`${styles.radioOption} ${formData.goal === 'הפיכת המסחר לקריירה עיקרית' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="goal"
                    value="הפיכת המסחר לקריירה עיקרית"
                    checked={formData.goal === 'הפיכת המסחר לקריירה עיקרית'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>הפיכת המסחר לקריירה עיקרית</span>
                </label>
                <label className={`${styles.radioOption} ${formData.goal === 'עמידה בתנאי חשבון ממומן וקבלת הקצאת הון' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="goal"
                    value="עמידה בתנאי חשבון ממומן וקבלת הקצאת הון"
                    checked={formData.goal === 'עמידה בתנאי חשבון ממומן וקבלת הקצאת הון'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>עמידה בתנאי חשבון ממומן וקבלת הקצאת הון</span>
                </label>
              </div>
              {errors.goal && <p className={styles.errorText}>{errors.goal}</p>}
            </div>

            {/* Question 3 */}
            <div className={styles.formSection}>
              <h3 className={styles.questionTitle}>
                <span className={styles.questionNumber}>3</span>
                כמה זמן ריאלי אתה מוכן להקדיש ללמידה ולתרגול בשבוע?
              </h3>
              <div className={styles.radioGroup}>
                <label className={`${styles.radioOption} ${formData.timeCommitment === 'עד שעתיים' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="timeCommitment"
                    value="עד שעתיים"
                    checked={formData.timeCommitment === 'עד שעתיים'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>עד שעתיים</span>
                </label>
                <label className={`${styles.radioOption} ${formData.timeCommitment === '3-5 שעות' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="timeCommitment"
                    value="3-5 שעות"
                    checked={formData.timeCommitment === '3-5 שעות'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>3-5 שעות</span>
                </label>
                <label className={`${styles.radioOption} ${formData.timeCommitment === 'יותר מ-5 שעות' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="timeCommitment"
                    value="יותר מ-5 שעות"
                    checked={formData.timeCommitment === 'יותר מ-5 שעות'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>יותר מ-5 שעות</span>
                </label>
              </div>
              {errors.timeCommitment && <p className={styles.errorText}>{errors.timeCommitment}</p>}
            </div>

            {/* Question 4 */}
            <div className={styles.formSection}>
              <h3 className={styles.questionTitle}>
                <span className={styles.questionNumber}>4</span>
                האם ברור לך שמדובר בתהליך לימודי ומעשי הדורש משמעת, תרגול והתמדה לאורך זמן?
              </h3>
              <div className={styles.radioGroup}>
                <label className={`${styles.radioOption} ${formData.disciplineAware === 'כן' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="disciplineAware"
                    value="כן"
                    checked={formData.disciplineAware === 'כן'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>כן</span>
                </label>
                <label className={`${styles.radioOption} ${formData.disciplineAware === 'לא בטוח' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="disciplineAware"
                    value="לא בטוח"
                    checked={formData.disciplineAware === 'לא בטוח'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>לא בטוח</span>
                </label>
              </div>
              {errors.disciplineAware && <p className={styles.errorText}>{errors.disciplineAware}</p>}
            </div>

            {/* Question 5 - Open Question */}
            <div className={styles.formSection}>
              <h3 className={styles.questionTitle}>
                <span className={styles.questionNumber}>5</span>
                שאלה פתוחה
              </h3>
              <p className={styles.questionSubtext}>
                למה החלטת להתחיל ללמוד מסחר דווקא עכשיו, ומה היעד שלך בהתקדמות לחשבון ממומן?
              </p>
              <textarea
                name="openQuestion"
                value={formData.openQuestion}
                onChange={handleInputChange}
                className={styles.formTextarea}
                placeholder="ספר לנו..."
                rows="4"
                disabled={isSubmitting || submitted}
              />
            </div>

            {/* Privacy Checkbox */}
            <div className={styles.privacyCheckbox}>
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  name="agreed"
                  checked={agreed}
                  onChange={() => setAgreed(!agreed)}
                  disabled={isSubmitting || submitted}
                />
                <span className={styles.checkboxCustom}></span>
                <span>קראתי ואני מאשר/ת את תנאי השימוש ומדיניות הפרטיות</span>
              </label>
              {errors.agreed && <p className={styles.errorText}>{errors.agreed}</p>}
            </div>

            {/* Submit Button */}
            <div className={styles.formButtons}>
              <button
                className={`${styles.submitButton} ${isSubmitting ? styles.submitting : ''} ${submitted ? styles.submitted : ''}`}
                onClick={handleContactSubmit}
                disabled={isSubmitting || submitted}
              >
                {isSubmitting ? (
                  <>
                    <span className={styles.spinner}></span>
                    שולח...
                  </>
                ) : submitted ? (
                  <>
                    <svg viewBox="0 0 24 24" fill="currentColor" className={styles.successIcon}>
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
                    </svg>
                    נשלח בהצלחה!
                  </>
                ) : (
                  'שליחה וקבלת התאמה אישית'
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SecondScreen;